import React from 'react';
import cx from 'classnames';

import styles from './TextInput.module.scss';

const TextInput = ({
  children,
  label,
  onChange,
  required = false,
  error = false,
  type = 'text',
  value,
  ...props
}) => {
  const [hasValue, setHasValue] = React.useState(props.defaultValue);
  const [defaultValue] = React.useState(value);

  const handleChange = React.useCallback(
    (event) => {
      setHasValue(event.currentTarget.value);
      onChange(event);
    },
    [],
  );

  const className = cx({
    [styles.root]: true,
    [styles.error]: error,
    [styles.hasValue]: hasValue,
  });

  return (
    <div className={className}>
      <label>
        <span className={styles.label}>
          {label} {required && <span className={styles.required}>*</span>}
        </span>
        <input
          type={type}
          className={styles.input}
          title={label}
          onChange={handleChange}
          defaultValue={defaultValue}
          {...props}
        />
      </label>
    </div>
  );
}
export default TextInput;
